import { logoutRequest } from '@/services/API/auth/AuthRequestService'
import { getLoginModuleData } from '@/services/API/module/ModuleService'
import axios from 'axios'
import TBK from '../../../services/tbk'

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const loginActions = ({ dispatch, commit }, { response, params }) => {
    localStorage.setItem('user', JSON.stringify(response.data.user))
    localStorage.setItem('user-token', response.data.user_token)
    localStorage.setItem('cash_desk_token', response.data.cash_desk_token)
    commit('SET_CASH_DESK_TOKEN', response.data.cash_desk_token)
    if (response.data.permissions && response.data.permissions.length)
        localStorage.setItem(
            'permissions',
            JSON.stringify(response.data.permissions)
        )
    // reload main page without token
    // dispatch('fetchCashDeskID')
    if (params.tbk_url) dispatch('setTbk', { url: params.tbk_url, id: null })
    let mainPageWithoutParams = window.location.href.split('?')[0] // same page without params
    window.location = mainPageWithoutParams
}

const goToMenu = async ({ state }) => {
    let res = await getLoginModuleData()
    deleteStorageData()
    let url = res.data.g_login_module.url_module
    if (state.cash_desk_token)
        url = url + `#/?cash_desk_token=${state.cash_desk_token}`
    window.location.assign(url)
}

/**
 * @description
 * Call logout request and delete user data if backend response is successed
 *
 * @param {Object} commit
 * @return {Promise} server response of request
 */
const logoutRequestAction = ({ commit }) => {
    return new Promise((resolve, reject) => {
        logoutRequest()
            .then(response => {
                logoutActions({ commit })
                resolve(response)
            })
            .catch(err => {
                logoutActions({ commit })
                reject(err)
            })
    })
}

const fetchCasDeskStatus = ({ dispatch, state }) =>
    new Promise((resolve, reject) => {
        if ([undefined, null].includes(state.cash_desk_id)) {
            setTimeout(() => dispatch('fetchCasDeskStatus', 200))
        } else {
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/pos_daily_cash_initial_resume?pos_cash_desk_id=' +
                state.cash_desk_id
            axios
                .get(route)
                .then(r => {
                    dispatch('setOpenCashDesk', true)
                    resolve(true)
                    return
                })
                .catch(e => {
                    if (
                        e &&
                        e.response &&
                        e.response.data &&
                        e.response.data.error ===
                            'No existe una apertura de caja activa.'
                    ) {
                        dispatch('setOpenCashDesk', null)
                        resolve('closed')
                    } else reject(e)
                })
        }
    })

const deleteStorageData = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('user-token')
    localStorage.removeItem('cash_desk_token')
    localStorage.removeItem('cash_desk_id')
    localStorage.removeItem('permissions')
    localStorage.removeItem('tbk_url')
    localStorage.removeItem('tbk-url')
    localStorage.removeItem('cash-desk-open')
    localStorage.removeItem('company-data')
}

/**
 * @description
 * Remove user data of local storage and call mutation authLogout (set user token to '')
 *
 * @param {object} commit
 * @return {void}
 */
const logoutActions = ({ commit }) => {
    commit('authLogout')
    deleteStorageData()
    delete axios.defaults.headers.common['Authorization']
}

const setOpenCashDesk = ({ commit }, boolean) => {
    commit('SET_OPEN_CASH_DESK', boolean)
    localStorage.setItem('cash-desk-open', boolean)
}

const setMustCloseCashDesk = ({ commit }, boolean) => {
    commit('SET_MUST_CLOSE_CASH_DESK', boolean)
    localStorage.setItem('must-open-cash-desk', boolean)
}

const fetchMustCloseCashDesk = ({ dispatch, state }) =>
    new Promise((resolve, reject) => {
        if ([undefined, null].includes(state.cash_desk_id)) {
            setTimeout(() => dispatch('fetchCasDeskStatus', 200))
        } else {
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/pos_cash_desk/' +
                state.cash_desk_id +
                '/check_open_cash_past_days'
            axios
                .get(route)
                .then(r => {
                    dispatch('setMustCloseCashDesk', r.data.open_cash)
                    resolve(r.data.open_cash)
                    return
                })
                .catch(reject)
        }
    })

const hasRole = ({ state }, role) => {
    if (state.user && state.user.roles && state.user.roles.length)
        return state.user.roles.some(r => r === role)
}

const fetchCashDeskID = async ({ commit, state, dispatch }) => {
    if (!state.cash_desk_token) return
    let route = process.env.VUE_APP_API_ROUTE + '/pos_cash_desk_by_token'
    route += `?cash_desk_token${state.cash_desk_token}`
    let r = null
    try {
        r = await axios.get(route)
    } catch (e) {
        setTimeout(() => {
            dispatch('fetchCashDeskID')
        }, 200)
        return
    }
    if (!r) return
    localStorage.setItem('cash_desk_id', r.data.id)
    dispatch('setTbk', { url: localStorage.getItem('tbk-url'), id: r.data.id })
    commit('SET_CASH_DESK_ID', r.data.id)
    return r.data.id
}

const setTbk = ({ commit }, { url, id }) => {
    if (!url) url = 'https://localhost:5000/api/'
    if (!id) id = null
    commit('SET_TBK', new TBK(url, id))
    localStorage.setItem('tbk-url', url)
}

export default {
    loginActions,
    logoutRequestAction,
    logoutActions,
    setOpenCashDesk,
    fetchCashDeskID,
    setTbk,
    hasRole,
    goToMenu,
    fetchCasDeskStatus,
    setMustCloseCashDesk,
    fetchMustCloseCashDesk,
}
